var map = {
	"./404.svg": 33530,
	"./backicon.svg": 74267,
	"./centerAglin.svg": 56888,
	"./cplbsqicon.svg": 72600,
	"./cplbzkicon.svg": 89524,
	"./cpscicon.svg": 19177,
	"./diyerror.svg": 72928,
	"./diyjinggao.svg": 82702,
	"./diytishi.svg": 61165,
	"./hzwzicon.svg": 76424,
	"./kjfwicon.svg": 83921,
	"./leftAglin.svg": 29725,
	"./leftbutton.svg": 30942,
	"./lichengpeituYuan.svg": 36359,
	"./logo.svg": 79401,
	"./logo1.svg": 9851,
	"./mailicon.svg": 40021,
	"./phoneicon.svg": 84626,
	"./rightAglin.svg": 7336,
	"./ryicon.svg": 70275,
	"./sjkicon.svg": 67171,
	"./syznicon.svg": 94737,
	"./szzylogo.svg": 3853,
	"./wxewmicon.svg": 92622,
	"./wxicon.svg": 16286,
	"./ysicon1.svg": 76140,
	"./ysicon1_xz.svg": 8483,
	"./ysicon2.svg": 82821,
	"./ysicon2_xz.svg": 27754,
	"./ysicon3.svg": 39542,
	"./ysicon3_xz.svg": 76994,
	"./yunbutton.svg": 51760,
	"./zhyzicon.svg": 87740,
	"./zlzxicon.svg": 61183,
	"./zzicon.svg": 55911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;